// These used to be concatenated together in a hand-maintained, order-sensitive
// list in Gruntfile.js. esbuild follows these imports instead, so adding a new
// slide file no longer means remembering to register it in the build config --
// which is how shareIgSlide.js and shareScSlide.js ended up never being built
// at all.
//
// The slides below that are only referenced from the commented-out
// registerSlide() blocks are imported anyway, so uncommenting a block is all it
// takes to bring one back. esbuild drops whatever goes unused.
import { SlideManager } from './slideManager.js';
import { ClickRainSlide } from './slides/clickrainSlide.js';
import { CrPromoSlide } from './slides/crPromoSlide.js';
import { InstagramSlide } from './slides/instagramSlide.js';
import { LeaderboardSlide } from './slides/leaderboardSlide.js';
import { LlPromoSlide } from './slides/llPromoSlide.js';
import { NewsSlide } from './slides/newsSlide.js';
import { SayingsSlide } from './slides/sayingsSlide.js';
import { ShareIgSlide } from './slides/shareIgSlide.js';
import { ShareScSlide } from './slides/shareScSlide.js';
import { SponsorsSlide } from './slides/sponsorsSlide.js';
import { TwitterSlide } from './slides/twitterSlide.js';
import { VideoSponsorSlide } from './slides/videoSponsorSlide.js';

// Create the slide manager, and add all of the slides.
var slideManager = new SlideManager();

var crSlide = new ClickRainSlide(slideManager);

slideManager.registerSlide({
	'id': 'clickrain',
	'name': 'Click Rain',
	'template': '#slide-clickrain',
	'duration': 7500,
	'action': crSlide
});
slideManager.registerSlide({
	'id': 'imagesetLogos',
	'name': 'Logos',
	'template': '#slide-sayings',
	'duration': 5000,
	'action': new SayingsSlide('logos')
});
slideManager.registerSlide({
	'id': 'news',
	'name': 'News',
	'template': '#slide-news',
	'duration': 10000,
	'action': new NewsSlide()
});
slideManager.registerSlide({
	'id': 'imagesetSponsors1',
	'name': 'Sponsors #1',
	'template': '#slide-sayings',
	'duration': 5000,
	'action': new SayingsSlide('sponsors')
});
slideManager.registerSlide({
	'id': 'amateurgross',
	'name': 'Leaderboard - Amateur (Gross)',
	'template': '#slide-leaderboard',
	'duration': -1,
	'action': new LeaderboardSlide('amateurgross', 'Amateur', 'Gross')
});
slideManager.registerSlide({
    'id': 'imagesetQuotes1',
    'name': 'Sayings / Quotes #1',
    'template': '#slide-sayings',
    'duration': 5000,
    'action': new SayingsSlide('quotes')
});
slideManager.registerSlide({
	'id': 'imagesetSponsors2',
	'name': 'Sponsors #2 (CR/LL)',
	'template': '#slide-sayings',
	'duration': 8000,
	'action': new SayingsSlide('cr-sponsors')
});
slideManager.registerSlide({
	'id': 'amateurnet',
	'name': 'Leaderboard - Amateur (Net)',
	'template': '#slide-leaderboard',
	'duration': -1,
	'action': new LeaderboardSlide('amateurnet', 'Amateur', 'Net')
});
slideManager.registerSlide({
    'id': 'imagesetQuotes2',
    'name': 'Sayings / Quotes #2',
    'template': '#slide-sayings',
    'duration': 5000,
    'action': new SayingsSlide('quotes')
});
slideManager.registerSlide({
	'id': 'imagesetSponsors3',
	'name': 'Sponsors #3',
	'template': '#slide-sayings',
	'duration': 5000,
	'action': new SayingsSlide('sponsors')
});
slideManager.registerSlide({
	'id': 'teamflight1',
	'name': 'Leaderboard - Flight 1',
	'template': '#slide-leaderboard',
	'duration': -1,
	'action': new LeaderboardSlide('teamflight1', 'Team One')
});
slideManager.registerSlide({
    'id': 'imagesetQuotes3',
    'name': 'Sayings / Quotes #3',
    'template': '#slide-sayings',
    'duration': 5000,
    'action': new SayingsSlide('quotes')
});
slideManager.registerSlide({
	'id': 'imagesetSponsors4',
	'name': 'Sponsors #4 (CR/LL)',
	'template': '#slide-sayings',
	'duration': 8000,
	'action': new SayingsSlide('cr-sponsors')
});
slideManager.registerSlide({
	'id': 'teamflight2',
	'name': 'Leaderboard - Flight 2',
	'template': '#slide-leaderboard',
	'duration': -1,
	'action': new LeaderboardSlide('teamflight2', 'Team Two')
});
slideManager.registerSlide({
    'id': 'imagesetQuotes4',
    'name': 'Sayings / Quotes #4',
    'template': '#slide-sayings',
    'duration': 5000,
    'action': new SayingsSlide('quotes')
});
slideManager.registerSlide({
	'id': 'imagesetSponsors5',
	'name': 'Sponsors #5',
	'template': '#slide-sayings',
	'duration': 5000,
	'action': new SayingsSlide('sponsors')
});
slideManager.registerSlide({
	'id': 'professional',
	'name': 'Leaderboard - Professional',
	'template': '#slide-leaderboard',
	'duration': -1,
	'action': new LeaderboardSlide('professional', 'Professional')
});
slideManager.registerSlide({
    'id': 'imagesetQuotes5',
    'name': 'Sayings / Quotes #5',
    'template': '#slide-sayings',
    'duration': 5000,
    'action': new SayingsSlide('quotes')
});
slideManager.registerSlide({
    'id': 'imagesetConcertLight',
    'name': 'Concert Slide (Light)',
    'template': '#slide-sayings',
    'duration': 7500,
    'action': new SayingsSlide('concertLight')
});
slideManager.registerSlide({
    'id': 'imagesetConcertDark',
    'name': 'Concert Slide (Dark)',
    'template': '#slide-sayings',
    'duration': 7500,
    'action': new SayingsSlide('concertDark')
});
slideManager.registerSlide({
	'id': 'imagesetTys',
	'name': 'Thank Yous',
	'template': '#slide-sayings',
	'duration': 5000,
	'action': new SayingsSlide('tys')
});
// slideManager.registerSlide({
// 	'id': 'sharesc',
// 	'name': 'Share on Snapchat',
// 	'template': '#slide-share-sc',
// 	'duration': 5000
// });
// slideManager.registerSlide({
//     'id': 'sayings2',
//     'name': 'Sayings #2',
//     'template': '#slide-sayings',
//     'duration': 5000,
//     'action': new SayingsSlide()
// });
// slideManager.registerSlide({
// 	'id': 'sponsors',
// 	// Name is used only for debugging.
// 	'name': 'Sponsors',
// 	// The template that has the layout information.
// 	'template': '#slide-sponsors',
// 	// How long the slide is shown, in milliseconds.
// 	'duration': 10000,
// 	// A class to handle various callback events
// 	'action': new SponsorsSlide()
// });
// slideManager.registerSlide({
// 	'id': 'crpromo1',
// 	// Name is used only for debugging.
// 	'name': 'Click Rain Promotion (People-first)',
// 	// The template that has the layout information.
// 	'template': '#slide-cr-promo',
// 	// How long the slide is shown, in milliseconds.
// 	'duration': 5000,
// 	// A class to handle various callback events
// 	'action': new CrPromoSlide()
// });
// slideManager.registerSlide({
// 	'id': 'llpromo1',
// 	// Name is used only for debugging.
// 	'name': 'Lemonly Promotion',
// 	// The template that has the layout information.
// 	'template': '#slide-ll-promo',
// 	// How long the slide is shown, in milliseconds.
// 	'duration': 5000,
// 	// A class to handle various callback events
// 	'action': new LlPromoSlide()
// });
// slideManager.registerSlide({
// 	'id': 'crpromo2',
// 	// Name is used only for debugging.
// 	'name': 'Click Rain Promotion (Animation #1)',
// 	// The template that has the layout information.
// 	'template': '#slide-cr-promo-grey1',
// 	// How long the slide is shown, in milliseconds.
// 	'duration': 5000,
// 	// A class to handle various callback events
// 	'action': new CrPromoSlide()
// });
// slideManager.registerSlide({
//     'id': 'sayings3',
//     'name': 'Sayings #3',
//     'template': '#slide-sayings',
//     'duration': 5000,
//     'action': new SayingsSlide()
// });
// slideManager.registerSlide({
// 	'id': 'videosponsor',
// 	// Name is used only for debugging.
// 	'name': 'Video Sponsor',
// 	// The template that has the layout information.
// 	'template': '#slide-video-sponsor',
// 	// How long the slide is shown, in milliseconds.
// 	'duration': 4000,
// 	// A class to handle various callback events
// 	'action': new VideoSponsorSlide()
// });
// slideManager.registerSlide({
// 	'id': 'twitter',
// 	'name': 'Twitter',
// 	'template': '#slide-twitter',
// 	'duration': -1,
// 	'action': new TwitterSlide(4000)
// });
// slideManager.registerSlide({
//     'id': 'sayings4',
//     'name': 'Sayings #4',
//     'template': '#slide-sayings',
//     'duration': 5000,
//     'action': new SayingsSlide()
// });
// slideManager.registerSlide({
// 	'id': 'teamflight2',
// 	'name': 'Leaderboard - Flight 2',
// 	'template': '#slide-leaderboard',
// 	'duration': -1,
// 	'action': new LeaderboardSlide('teamflight2', 'Team Two')
// });
// slideManager.registerSlide({
// 	'id': 'shareig',
// 	'name': 'Share on Instagram',
// 	'template': '#slide-share-ig',
// 	'duration': 5000
// });
// slideManager.registerSlide({
// 	'id': 'instagram',
// 	'name': 'Instagram',
// 	'template': '#slide-instagram',
// 	'duration': 20000,
// 	'action': new InstagramSlide()
// });
// slideManager.registerSlide({
// 	'id': 'crpromo4',
// 	// Name is used only for debugging.
// 	'name': 'Stratus Promotion',
// 	// The template that has the layout information.
// 	'template': '#slide-cr-promo-stratus',
// 	// How long the slide is shown, in milliseconds.
// 	'duration': 5000,
// 	// A class to handle various callback events
// 	'action': new CrPromoSlide()
// });
// slideManager.registerSlide({
// 	'id': 'crpromo3',
// 	// Name is used only for debugging.
// 	'name': 'Click Rain Promotion (Animation #2)',
// 	// The template that has the layout information.
// 	'template': '#slide-cr-promo-grey2',
// 	// How long the slide is shown, in milliseconds.
// 	'duration': 5000,
// 	// A class to handle various callback events
// 	'action': new CrPromoSlide()
// });
// slideManager.registerSlide({
//     'id': 'sayings5',
//     'name': 'Sayings #5',
//     'template': '#slide-sayings',
//     'duration': 5000,
//     'action': new SayingsSlide()
// });
// slideManager.registerSlide({
// 	'id': 'professional',
// 	'name': 'Leaderboard - Professional',
// 	'template': '#slide-leaderboard',
// 	'duration': -1,
// 	'action': new LeaderboardSlide('professional', 'Professional')
// });
// slideManager.registerSlide({
// 	'id': 'imageset-tys',
// 	'name': 'Thank Yous',
// 	'template': '#slide-sayings',
// 	'duration': 5000,
// 	'action': new SayingsSlide('tys')
// });

// As early as possible, get which slides should display, so we don't show
// slides we don't want to show the first time through.
crSlide.prepare();

var body = null;
slideManager.onSlideCreated = function(slide) {
	// Get a reference to the <body> tag.
	if (!body) {
		body = document.querySelector('body');
	}

	body.appendChild(slide.element);
};

var currentSlide = null;
slideManager.onSlideChanging = function(slide) {
	// Get a reference to the <body> tag.
	if (!body) {
		body = document.querySelector('body');
	}

	// Get the previous slide and current slide, including their HTML elements
	var previousSlide = currentSlide;
	var previousSlideElement = null;
	if (previousSlide) {
		previousSlideElement = previousSlide.element;
	}
	currentSlide = slide;
	var currentSlideElement = currentSlide.element;

	// Remove all transition classes from all the slides. These classes can
	// stack up if the boards aren't actually visible, because the browsers
	// try to optimize the transitions and don't do anything if the page isn't
	// visible.
	slideManager.slides.forEach(function(slide) {
		if (slide.element) {
			slide.element.classList.remove('slide-enter');
			slide.element.classList.remove('slide-enter-active');
			slide.element.classList.remove('slide-exit');
			slide.element.classList.remove('slide-exit-active');
		}
	});

	// Set up what happens when a transition ends.
	var currentSlideTransitionEnd = function(e) {
		// We can get this event when events end in child pages. That is
		// definitely not what we want. So, only handle this when the target
		// is the element on which the event is set.
		if (e.target !== this) {
			return;
		}
		// Remove the listener. We don't want to end up with a whole slew
		// of listeners that cause weird bugs.
		currentSlideElement.removeEventListener('transitionend', currentSlideTransitionEnd, false);
		// Remove the transition classes.
		currentSlideElement.classList.remove('slide-enter');
		currentSlideElement.classList.remove('slide-enter-active');
	};
	var previousSlideTransitionEnd = function(e) {
		// We can get this event when events end in child pages. That is
		// definitely not what we want. So, only handle this when the target
		// is the element on which the event is set.
		if (e.target !== this) {
			return;
		}
		// Remove the listener. We don't want to end up with a whole slew
		// of listeners that cause weird bugs.
		previousSlideElement.removeEventListener('transitionend', previousSlideTransitionEnd, false);
		// Remove the transition classes.
		previousSlideElement.classList.remove('slide-exit');
		previousSlideElement.classList.remove('slide-exit-active');
	};

	// Set up those transition events.
	currentSlideElement.addEventListener('transitionend', currentSlideTransitionEnd);
	if (previousSlideElement)
		previousSlideElement.addEventListener('transitionend', previousSlideTransitionEnd);

	// Start the transition from one slide to the next.
	// These classes allow us to set up various properties before we do the
	// transition.
	if (previousSlideElement) {
		previousSlideElement.classList.add('slide-exit');
		previousSlideElement.classList.remove('active');
	}
	currentSlideElement.classList.add('slide-enter');
	currentSlideElement.classList.add('active');

	// And these classes do the transition. We need this in a setTimeout
	// so that the CSS knows to apply slide-(enter|exit) first, and then
	// apply these.
	setTimeout(function() {
		if (previousSlideElement)
			previousSlideElement.classList.add('slide-exit-active');
		currentSlideElement.classList.add('slide-enter-active');
	}, 0);
};

// Once the DOM is ready, start the slides.
document.addEventListener('DOMContentLoaded', function() {
	slideManager.start();
}, false);
document.addEventListener('keydown', function(e) {
	if (e.keyCode === 39) {
		slideManager.nextSlide();
	}
});
